import { render, staticRenderFns } from "./DisplayWarningInShopingCart.vue?vue&type=template&id=056ba863&"
import script from "./DisplayWarningInShopingCart.vue?vue&type=script&lang=js&"
export * from "./DisplayWarningInShopingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports